<template>
  <div>
    <modal-row label="Password">
      <form class="my-3">
        <b-form-input autocomplete="new-password" type="password" v-model="change.password.new" ref="password"
                      placeholder="New Password"/>
        <b-form-input autocomplete="new-password" type="password" v-model="change.password.confirm"
                      placeholder="Confirm " class="mt-1"/>
        <b-btn size="sm" variant="primary" @click="process('password')" class="float-right mt-1 mb-3">Change</b-btn>
      </form>
    </modal-row>

    <modal-row label="Pin">
      <form class="my-3">
        <b-form-input autocomplete="new-password" v-model="change.pin.new" type="password" ref="pin"
                      placeholder="New Pin"/>
        <b-form-input autocomplete="new-password" v-model="change.pin.confirm" type="password" placeholder="Confirm "
                      class="mt-1"/>
        <b-btn size="sm" variant="primary" @click="process('pin')" class="float-right mt-1 mb-3">Change</b-btn>
      </form>
    </modal-row>
  </div>
</template>

<script>
export default {
  name: "user-password",

  props: {
    user: Object,
  },

  data() {
    return {
      change: {
        password: { new: '', confirm: ''},
        pin: { new: '', confirm: ''}
      }
    }
  },

  methods: {
    process(what) {
      if (this.change[what].new !== this.change[what].confirm) {
        this.alert('New ' + what + ' Mismatch.  Try Again')
        this.$refs[what].focus()
        return
      }

      const data = {}
      data[what] = this.change[what].new

      this.asyncAction(this.user._links.self_url.href, 'PUT', {
        data
      }).then(() => {
        this.change[what] = {new: '', confirm: ''}
        this.toast(what.charAt(0).toUpperCase() + what.slice(1) + ' has been changed.')
      }).catch(() => {
        this.$refs[what].focus()
      })
    }
  }
}
</script>

<style scoped>

</style>